import { salePriceFromMargin } from 'helpers/margin';
import { Surgerie } from 'types/surgerie';

const round = (value: number) => Math.round(value * 100) / 100;

// Recalcula pacotes, custo e venda depois de editar um valor. A venda continua seguindo a margem do procedimento.
export function withUpdatedTotals(budget: Surgerie): Surgerie {
  const valuePackages = budget.packages.reduce((sum, item) => sum + (item.package?.sale_price || 0), 0);
  const valueBudget =
    valuePackages + (budget.value_doctor || 0) + (budget.value_hospital || 0) + (budget.value_anesthetist || 0);
  const valueTotal = salePriceFromMargin(valueBudget, budget.procedure?.profit_margin);

  return {
    ...budget,
    value_packages: valuePackages,
    value_budget: valueBudget,
    value_total: valueTotal,
    value_markup: round(valueTotal - valueBudget),
  };
}
